// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/style.css
// module id = 1446
// module chunks = 0